module.exports = __webpack_public_path__ + "img/hz_13.7afeabee.jpg";